import type { ContextSlug } from "@/entities/context";

import {
  useOrganizationContextList,
  useOrganizationCustomContext,
} from "@/modules/organization/organization-context";

export const useOrganizationContextLabel = (context: ContextSlug) => {
  const { organizations } = useOrganizationContextList();
  const { showCustomContext } = useOrganizationCustomContext();

  const organization = organizations.find((org) => org.slug === context);

  return {
    organization: showCustomContext(context) ? organization : undefined,
  };
};
